import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../contexts/halfYearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import TableMainSearch from "../../common/MainSearch";
import MainBodyTabs from "../financeTabs";
import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import DataTable from "./ContractorsList";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";
import MainPrintLink from "../../common/MainPrint";

const Contractors = (props) => {
  const [data, updateData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  const routeTabs = [
    {
      name: "مصرف ها",
      path: "/mis/expenses/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/expenseBudgets",
    },
    {
      name: "طرف های قرارداد",
      path: "/mis/contractors",
    },
    {
      name: "حسابات قبلی استادان",
      path: "/mis/facultiesPastBalance",
    },
    {
      name: "امتیازات استادان",
      path: "/mis/teacherBenefits",
    },
  ];

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `contractors?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        updateData(data);
      });
    } catch ({ response }) {
      updateData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={"طرف های قرارداد"} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainButton
            title={lbl.AddContractor}
            handleClick={() => togglePopUp({ form: "contractor-form" })}
            type={"add"}
          />
          <MainPrintLink path={"contractors"} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={routeTabs} {...props} />
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default Contractors;
